import { getPageAllowedRoles } from "../../config/roles";

function getNavigationItemDisplayTextValue(page) {
  switch (page.Id) {
    case "blacklist_and_mail_exclusion":
    case "g4c_communicationoptions":
    case "automation_dashboard":
    case "journey_planner":
    case "journal_daily_report":
    case "page":
    case "report":
    case "search":
    case "sitemap":
      return page.RecordName;
    default:
      return page.ListName;
  }
}

function getNavigationItemToAlwaysDisplayDetails(page) {
  switch (page) {
    case "/data-imports":
      return {
        to: "/data-imports",
        text: "Data Imports",
        listName: "Data Imports",
        recordName: "Data Imports",
        allowedRoles: getPageAllowedRoles("data-import"),
      };
    case "/search":
      return {
        to: "/search",
        text: "Search",
        recordName: "Search",
        allowedRoles: getPageAllowedRoles("search"),
      };
    case "/sitemap":
      return {
        to: "/sitemap",
        text: "Sitemap",
        recordName: "Sitemap",
        allowedRoles: getPageAllowedRoles("sitemap"),
      };
    default:
      return {};
  }
}

function getNavigationItemDetails(page) {
  switch (page.Id) {
    case "account":
      return {
        identifiers: ["/accounts", "/account"],
        to: "/accounts",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("account"),
      };
    case "automation":
      return {
        identifiers: ["/automation-list", "/automation"],
        to: "/automation-list",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("automation"),
      };
    case "automation_dashboard":
      return {
        identifiers: ["/automation-dashboard"],
        to: "/automation-dashboard",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("automation-dashboard"),
      };
    case "journey_planner":
      return {
        identifiers: ["/journey-planner"],
        to: "/journey-planner",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("journey-planner"),
      };
    case "blacklist_and_mail_exclusion":
      return {
        to: "/blacklist",
        description:
          "Enable only if the client is trusted to responsibly manage blacklisted email addresses",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("blacklist"),
      };
    case "campaign":
      return {
        identifiers: ["/reporting-campaigns", "/reporting-campaign"],
        to: "/reporting-campaigns",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("campaign"),
      };
    case "contact":
      return {
        identifiers: ["/contacts", "/contact", "/contact-audit"],
        to: "/contacts",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("contact"),
      };
    case "data_import":
      return {
        identifiers: ["/data-imports", "/data-import"],
        to: "/data-imports",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("data-import"),
      };
    case "dwcompetition":
      return {
        identifiers: ["/competitions", "/competition"],
        to: "/competitions",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwcompetition"),
      };
    case "dwcompetitionstage":
      return {
        identifiers: ["/competition-stages", "/competition-stage"],
        to: "/competition-stages",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwcompetitionstage"),
      };
    case "dwdatamodel":
      return {
        identifiers: ["/data-models", "/data-model"],
        to: "/data-models",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwdatamodel"),
      };
    case "dweventprofile":
      return {
        identifiers: ["/event-profiles", "/event-profile"],
        to: "/event-profiles",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dweventprofile"),
      };
    case "dwfixture":
      return {
        identifiers: ["/fixtures", "/fixture"],
        to: "/fixtures",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwfixture"),
      };
    case "dwfixturegrade":
      return {
        identifiers: ["/fixture-grades", "/fixture-grade"],
        to: "/fixture-grades",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwfixturegrade"),
      };
    case "dwhomestatus":
      return {
        identifiers: ["/venue-statuses", "/venue-status"],
        to: "/venue-statuses",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwhomestatus"),
      };
    case "dwopponent":
      return {
        identifiers: ["/opponents", "/opponent"],
        to: "/opponents",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwopponent"),
      };
    case "dwopponenttype":
      return {
        identifiers: ["/opponent-types", "/opponent-type"],
        to: "/opponent-types",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwopponenttype"),
      };
    case "dwseason":
      return {
        identifiers: ["/seasons", "/season"],
        to: "/seasons",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwseason"),
      };
    case "dwseasonalperiod":
      return {
        identifiers: ["/seasonal-periods", "/seasonal-period"],
        to: "/seasonal-periods",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwseasonalperiod"),
      };
    case "dwteam":
      return {
        identifiers: ["/teams", "/team"],
        to: "/teams",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwteam"),
      };
    case "dwtickethospitalityproduct":
      return {
        identifiers: [
          "/ticket-hospitality-products",
          "/ticket-hospitality-product",
        ],
        to: "/ticket-hospitality-products",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles(
          "dwtickethospitalityproduct"
        ),
      };
    case "dwtype":
      return {
        identifiers: ["/types", "/type"],
        to: "/types",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("dwtype"),
      };
    case "g4c_abtest":
      return {
        identifiers: ["/abtests", "/abtest"],
        to: "/abtests",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("abtest"),
      };
    case "g4c_communication":
      return {
        identifiers: [
          "/email-communications",
          "/email-communication",
        ],
        to: "/email-communications",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication"),
      };
    case "g4c_communicationactivity":
      return {
        identifiers: [
          "/communication-activities",
          "/communication-activity",
        ],
        to: "/communication-activities",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-activity"),
      };
    case "g4c_communicationaudience":
      return {
        identifiers: ["/audiences", "/audience"],
        to: "/audiences",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-audience"),
      };
    case "g4c_communicationoptions":
      return {
        to: "/communication-settings",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("communication-settings"),
      };
    case "g4c_subscriptiongroup":
      return {
        identifiers: [
          "/email-preference-groups",
          "/email-preference-group",
        ],
        to: "/email-preference-groups",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("subscription-group"),
      };
    case "list":
      return {
        identifiers: [
          "/static-marketing-lists",
          "/static-marketing-list",
        ],
        to: "/static-marketing-lists",
        text: getNavigationItemDisplayTextValue(page),
        listName: page.ListName,
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("marketing-list"),
      };
    case "page":
      return {
        to: "/page/" + page.PageId,
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        url: page.URL,
        allowedRoles: getPageAllowedRoles("page"),
      };
    case "report":
      return {
        to: "/report/" + page.PageId,
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        workspaceId: page.WorkspaceId,
        reportId: page.ReportId,
        allowedRoles: getPageAllowedRoles("report"),
      };
    case "search":
      return {
        to: "/search",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("search"),
      };
    case "sitemap":
      return {
        to: "/sitemap",
        text: getNavigationItemDisplayTextValue(page),
        recordName: page.RecordName,
        allowedRoles: getPageAllowedRoles("sitemap"),
      };
    default:
      return {};
  }
}

function getDefaultDetailsForPage(page) {
  switch (page) {
    case "account":
      return {
        Id: "account",
        ListName: "Accounts",
        RecordName: "Account",
      };
    case "automation":
      return {
        Id: "automation",
        ListName: "Automation List",
        RecordName: "Automation",
      };
    case "automation_dashboard":
      return {
        Id: "automation_dashboard",
        ListName: null,
        RecordName: "Automation Dashboard",
      };
    case "journey_planner":
      return {
        Id: "journey_planner",
        ListName: null,
        RecordName: "Journey Planner",
      };
    case "blacklist_and_mail_exclusion":
      return {
        Id: "blacklist_and_mail_exclusion",
        ListName: null,
        RecordName: "Blacklist and Mail Exclusion",
      };
    case "campaign":
      return {
        Id: "campaign",
        ListName: "Reporting Campaigns",
        RecordName: "Reporting Campaign",
      };
    case "contact":
      return {
        Id: "contact",
        ListName: "Contacts",
        RecordName: "Contact",
      };
    case "data_import":
      return {
        Id: "data_import",
        ListName: "Data Imports",
        RecordName: "Data Import",
      };
    case "dwcompetition":
      return {
        Id: "dwcompetition",
        ListName: "Competitions",
        RecordName: "Competition",
      };
    case "dwcompetitionstage":
      return {
        Id: "dwcompetitionstage",
        ListName: "Competition Stages",
        RecordName: "Competition Stage",
      };
    case "dwdatamodel":
      return {
        Id: "dwdatamodel",
        ListName: "Data Models",
        RecordName: "Data Model",
      };
    case "dweventprofile":
      return {
        Id: "dweventprofile",
        ListName: "Event Profiles",
        RecordName: "Event Profile",
      };
    case "dwfixture":
      return {
        Id: "dwfixture",
        ListName: "Fixtures",
        RecordName: "Fixture",
      };
    case "dwfixturegrade":
      return {
        Id: "dwfixturegrade",
        ListName: "Fixture Grades",
        RecordName: "Fixture Grade",
      };
    case "dwhomestatus":
      return {
        Id: "dwhomestatus",
        ListName: "Venue Statuses",
        RecordName: "Venue Status",
      };
    case "dwopponent":
      return {
        Id: "dwopponent",
        ListName: "Opponents",
        RecordName: "Opponent",
      };
    case "dwopponenttype":
      return {
        Id: "dwopponenttype",
        ListName: "Opponent Types",
        RecordName: "Opponent Types",
      };
    case "dwseason":
      return {
        Id: "dwseason",
        ListName: "Seasons",
        RecordName: "Season",
      };
    case "dwseasonalperiod":
      return {
        Id: "dwseasonalperiod",
        ListName: "Seasonal Periods",
        RecordName: "Seasonal Period",
      };
    case "dwteam":
      return {
        Id: "dwteam",
        ListName: "Teams",
        RecordName: "Team",
      };
    case "dwtickethospitalityproduct":
      return {
        Id: "dwtickethospitalityproduct",
        ListName: "Ticket Hospitality Products",
        RecordName: "Ticket Hospitality Product",
      };
    case "dwtype":
      return {
        Id: "dwtype",
        ListName: "Types",
        RecordName: "Type",
      };
    case "g4c_abtest":
      return {
        Id: "g4c_abtest",
        ListName: "A/B Tests",
        RecordName: "A/B Test",
      };
    case "g4c_communication":
      return {
        Id: "g4c_communication",
        ListName: "Email Communications",
        RecordName: "Email Communication",
      };
    case "g4c_communicationactivity":
      return {
        Id: "g4c_communicationactivity",
        ListName: "Communication Activities",
        RecordName: "Communication Activity",
      };
    case "g4c_communicationaudience":
      return {
        Id: "g4c_communicationaudience",
        ListName: "Audiences",
        RecordName: "Audience",
      };
    case "g4c_communicationoptions":
      return {
        Id: "g4c_communicationoptions",
        ListName: null,
        RecordName: "Communication Settings",
      };
    case "g4c_subscriptiongroup":
      return {
        Id: "g4c_subscriptiongroup",
        ListName: "Email Preference Groups",
        RecordName: "Email Preference Group",
      };
    case "list":
      return {
        Id: "list",
        ListName: "Static Marketing Lists",
        RecordName: "Static Marketing List",
      };
    case "search":
      return {
        Id: "search",
        ListName: null,
        RecordName: "Search",
      };
    case "sitemap":
      return {
        Id: "sitemap",
        ListName: null,
        RecordName: "sitemap",
      };
    default:
      return {};
  }
}

export {
  getDefaultDetailsForPage,
  getNavigationItemToAlwaysDisplayDetails,
  getNavigationItemDisplayTextValue,
  getNavigationItemDetails,
};
